/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import { getLogs, getLog, printLog, createLogs, updateLogs, deleteLogs } from "Modules/manufacturing/logs/config/api.logs";

const state = {
    page: {},
    form: {},
    logs: [],
    log_options: [],
    selectedLog: {
        log_id: null,
        company_id: "",
        log_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        log_details: [],
    },
    logs_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_logs: {
        log_id: {
            name: "log_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        template_id: {
            name: "template_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        slug: {
            name: "slug",
            rules: "trim|max_length[36]|required",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        frequency: {
            name: "frequency",
            rules: "trim|max_length[10]",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        minutes: {
            name: "minutes",
            rules: "trim|max_length[12]|integer",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        capture: {
            name: "capture",
            rules: "trim|max_length[8]",
            max_len: "8",
            min_len: "",
            default_value: "",
        },
        machine_id: {
            name: "machine_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        part_id: {
            name: "part_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        supervisor_id: {
            name: "supervisor_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        notes: {
            name: "notes",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        file_id: {
            name: "file_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        version: {
            name: "version",
            rules: "trim|max_length[4]|integer|required",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        active: {
            name: "active",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "1",
        },
    },
};

// getters
const getters = {
    logs: (state) => {
        return state.logs;
    },
};

// actions
const actions = {
    async fetchLogs({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getLogs({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "log_options",
                        with: response.data.logs,
                    });
                } else {
                    commit("mutate", {
                        property: "logs",
                        with: response.data.logs,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchLog({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getLog(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedLog",
                    with: response.data.log,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printLog({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printLog(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveLog({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["log_id"] === "undefined" || body["log_id"] == null || body["log_id"] == "") {
                delete body["log_id"];
                response = await createLogs({ body: body, headers: config.headers });
            } else {
                let log_id = body["log_id"];
                delete body["log_id"];
                response = await updateLogs({ body: body, headers: config.headers }, log_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteLog({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteLogs(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
